import { React, useEffect, useState } from "react";
import Login_Page1 from "../assets/img/Login_Page1.png";
import gmail from "../assets/img/gmail.png";
import Password from "../assets/img/Password.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
const Loginpage = () => {
  const [input, setInput] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({});
  const navigate = useNavigate();

  // Redirect to dashboard if already logged in
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      const visualType = (() => {
        try {
          return JSON.parse(sessionStorage.getItem("visual_type"));
        } catch {
          return sessionStorage.getItem("visual_type");
        }
      })();
      if (visualType === "tomorrow") {
        navigate("/CancerTomorrow");
      } else if (visualType === "overtime") {
        navigate("/CancerOvertime");
      } else {
        navigate("/Visualization");
      }
    }
  }, [navigate]);

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
    setStatus("");
  };
  const emailValidator = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const validateLogin = () => {
    const errorMessages = {};
    if (!input.email) {
      errorMessages.email = "Email is required";
    } else if (!emailValidator(input.email)) {
      errorMessages.email = "Invalid email Format";
    }
    if (!input.password) {
      errorMessages.password = "Password is required";
    }
    setErrors(errorMessages);
    return Object.keys(errorMessages).length === 0;
  };
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  const loginSubmit = async (e) => {
    e.preventDefault();
    if (!validateLogin()) return;

    try {
      const response = await axios.post("/user-login", input);
      const loginResponse = response.data;
      // Success
      if (loginResponse.response_code === 200) {
        sessionStorage.setItem("token", loginResponse.token.remember_token);
        sessionStorage.setItem("projection_year",loginResponse.projection_year); // static start year from backend env
        sessionStorage.setItem(
          "userDetails",
          JSON.stringify(loginResponse.userDetails)
        );

        setStatus({
          success: true,
          response_code: loginResponse.response_code,
          message: loginResponse.message,
        });
      }
      //  Known backend errors (400, 422)
      else if (
        loginResponse.response_code === 400 ||
        loginResponse.response_code === 422
      ) {
        const message =
          Array.isArray(loginResponse.error) && loginResponse.error.length > 0
            ? loginResponse.error[0]
            : loginResponse.message || "Something went wrong";

        setStatus({
          success: false,
          response_code: loginResponse.response_code,
          message,
        });
      }
      //  Backend “failure” type, even if status is 200
      else if (loginResponse.type === "failure") {
        throw new Error(loginResponse.error?.[0] || "Something went wrong");
      }
      //  Fallback
      else {
        throw new Error(loginResponse.message || "Unexpected response");
      }
    } catch (error) {
      //  Handles thrown errors or network issues
      const message =
        error.response?.data?.error?.[0] ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      setStatus({
        success: false,
        response_code: error.response?.status || 400,
        message,
      });
    }
  };
  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 login-container">
        <div className="col-12 col-md-6 login-image-col">
          <img src={Login_Page1} alt="Login_Page1" className="img-fluid"></img>
        </div>
        <div className="col-12 col-md-6 login-form-col">
          <div className="row">
            <h2 className="fs-4 mb-4">Welcome,</h2>
            <p className="fs-5 fw-normal text-muted mb-4">
              Please Log in to your account or Create an Account
            </p>
            <form onSubmit={loginSubmit}>
              {/* Bootstrap Modal for Status Message */}
              {status.response_code && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div
                        className={`modal-header ${
                          status?.success
                            ? "bg-primary text-white"
                            : "bg-primary text-white"
                        }`}
                      >
                        <h5 className="modal-title">Login</h5>
                      </div>

                      <div className="modal-body">
                        <p className="text-center">{status?.message}</p>
                      </div>

                      <div className="modal-footer">
                        {status?.success ? (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              const visualType = (() => {
                                try {
                                  return JSON.parse(sessionStorage.getItem("visual_type"));
                                } catch {
                                  return sessionStorage.getItem("visual_type");
                                }
                              })();
                              if (visualType === "tomorrow") {
                                navigate("/CancerTomorrow");
                              } else if (visualType === "overtime") {
                                navigate("/CancerOvertime");
                              } else {
                                navigate("/Visualization");
                              }
                            }}
                          >
                            Ok
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => setStatus("")}
                          >
                            Close
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "23px", left: "10px" }}
                  src={gmail}
                  alt="gmail"
                ></img>
                <input
                  type="email"
                  name="email"
                  className=" form-control px-5 py-3 mb-2"
                  value={input.email}
                  onChange={handleChange}
                  placeholder="Enter your Email"
                ></input>
                {errors.email && (
                  <p className="text-danger small">{errors.email}</p>
                )}
              </div>
              <div className="position-relative">
                <img
                  style={{ position: "absolute", top: "18px", left: "12px" }}
                  src={Password}
                  alt="password"
                ></img>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control px-5 py-3 mb-2"
                  value={input.password}
                  onChange={handleChange}
                  placeholder="Enter your Password"
                ></input>
                <i
                  className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}
                  onClick={togglePassword}
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                />
                {errors.password && (
                  <p className="text-danger small">{errors.password}</p>
                )}
              </div>
              <div className="d-flex justify-content-end align-items-center mb-4">
                <Link to="/forgot-password" className="forgot-password">
                  Forgot password
                </Link>
              </div>
              <div className="login-submit d-flex align-items-center justify-content-center gap-3">
                <button
                  type="submit"
                  className="btn btn-primary submit-btn mb-3 px-4"
                >
                  Submit
                </button>

                <Link to="/Signup" className="login-link">
                  <button
                    type="button"
                    className="btn login-btn mb-3 shadow bg-white rounded-3 px-4"
                  >
                    Sign up
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Loginpage;
